import { Check, X, UserMinus, Crown } from "lucide-react";

const Avatar = ({ m }) => (m.picture
  ? <img src={m.picture} alt="" className="h-9 w-9 rounded-full object-cover" />
  : <div className="h-9 w-9 rounded-full bg-[#1E1E1E] border border-[#27272A] flex items-center justify-center text-sm font-semibold">{(m.name || "?").charAt(0).toUpperCase()}</div>);

const iconBtn = "h-8 w-8 rounded-full flex items-center justify-center transition-colors";

export const MemberRow = ({ m, isAdmin, onApprove, onReject, onRemove }) => (
  <li data-testid={`group-member-${m.user_id}`} className="flex items-center gap-3 px-4 py-3">
    <Avatar m={m} />
    <div className="min-w-0 flex-1">
      <div className="text-sm font-medium truncate flex items-center gap-1.5">
        {m.name}
        {m.role === "admin" && <Crown className="h-3.5 w-3.5 text-[#F59E0B]" aria-label="Admin" />}
      </div>
      {m.email && <div className="text-[11px] text-[#6B7280] truncate">{m.email}</div>}
    </div>
    {isAdmin && m.status === "pending" && (
      <div className="flex gap-1.5">
        <button type="button" data-testid={`group-approve-${m.user_id}`} aria-label="Approve" onClick={() => onApprove(m)} className={`${iconBtn} bg-[#10B981]/15 text-[#34D399] hover:bg-[#10B981]/25`}><Check className="h-4 w-4" /></button>
        <button type="button" data-testid={`group-reject-${m.user_id}`} aria-label="Decline" onClick={() => onReject(m)} className={`${iconBtn} bg-[#EF4444]/10 text-[#F87171] hover:bg-[#EF4444]/20`}><X className="h-4 w-4" /></button>
      </div>
    )}
    {isAdmin && m.status === "active" && m.role !== "admin" && (
      <button type="button" data-testid={`group-remove-${m.user_id}`} aria-label="Remove member" onClick={() => onRemove(m)} className={`${iconBtn} text-[#9CA3AF] hover:text-[#F87171] hover:bg-[#1E1E1E]`}><UserMinus className="h-4 w-4" /></button>
    )}
  </li>
);
